import { useAppStore } from './store/useAppStore';
import { HomePage } from '../pages/HomePage';
import { ProfilePage } from '../pages/ProfilePage';
import { ArchivePage } from '../pages/ArchivePage';
import { ArchiveDetailPage } from '../pages/ArchiveDetailPage';
import { getCaptureModule } from '../modules/capture/registry';
import { CameraSettingsSheet } from '../components/camera/CameraSettingsSheet';
import { ModuleSelector } from '../components/camera/ModuleSelector';
import { Notice } from '../components/ui/Notice';

const cameraStates = new Set(['CAMERA_INIT', 'CAMERA_READY', 'COUNTDOWN', 'CAPTURING', 'PROCESSING', 'CAMERA_SETTINGS', 'MODULE_SELECTOR']);

export function App() {
  const state = useAppStore((value) => value.state);
  const moduleId = useAppStore((value) => value.activeCaptureModuleId);
  const encounter = useAppStore((value) => value.currentEncounter);
  const module = getCaptureModule(moduleId);
  const CaptureView = module.CaptureView;
  const ResultView = module.ResultView;
  const isCameraState = cameraStates.has(state);

  let content = <HomePage/>;
  if (isCameraState) content = <CaptureView onCapture={() => undefined}/>;
  else if (state === 'RESULT' && encounter) content = <ResultView encounter={encounter}/>;
  else if (state === 'ARCHIVE') content = <ArchivePage/>;
  else if (state === 'ARCHIVE_DETAIL') content = <ArchiveDetailPage/>;
  else if (state === 'PROFILE') content = <ProfilePage/>;

  return <div className={`app-shell ${isCameraState ? 'is-camera' : ''}`}>
    <div className="device-frame">{content}{state === 'CAMERA_SETTINGS' ? <CameraSettingsSheet/> : null}{state === 'MODULE_SELECTOR' ? <ModuleSelector/> : null}<Notice/></div>
    <aside className="desktop-caption"><span>G-CAMERA / MOBILE WEB APP</span><b>ONE-OFF ENCOUNTER SYSTEM</b><small>TECHWEAR · EDITORIAL · LOCAL-FIRST</small></aside>
  </div>;
}
